/**
 * 言語設定ステップ
 */
import I18n from "features/shared/i18n";
import { CreatePlayerState } from "../types";

interface PlayerLanguageStepProps {
  state: CreatePlayerState;
  updateState: (updates: Partial<CreatePlayerState>) => void;
}

type LocaleOption = "ja" | "ja_kanji" | "en" | "zh_tw";

export const PlayerLanguageStep = ({ state, updateState }: PlayerLanguageStepProps) => {
  const localeOptions: { value: LocaleOption; label: string }[] = [
    { value: "ja", label: I18n.t("MSG_PARENT_PAGE_HIRAGANA") },
    { value: "ja_kanji", label: I18n.t("MSG_PARENT_PAGE_KANJI") },
    { value: "en", label: I18n.t("MSG_PARENT_PAGE_LANGUAGE_EN") },
    { value: "zh_tw", label: I18n.t("MSG_PARENT_PAGE_LANGUAGE_ZH_TW") },
  ];

  const handleLocaleChange = (locale: LocaleOption) => {
    updateState({ locale });
  };

  return (
    <div className="flex-col-el flex-center w-full min-h-full py-8">
      {/* タイトル */}
      <div className="flex-col-el flex-center mb-8">
        <p className="text-body text-textcolor-black text-[24px]">
          {I18n.t("MSG_CREATE_USER_TITLE_LANGUAGE_BY_PARENT")}
        </p>
      </div>

      {/* 言語選択 */}
      <div className="flex-col-el w-[400px] max-w-full gap-3">
        {localeOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => handleLocaleChange(option.value)}
            className={`flex-row-el items-center gap-3 w-full p-4 rounded-[12px] border-2 transition-all ${
              state.locale === option.value
                ? "bg-gray2-20 border-ink"
                : "bg-white border-transparent hover:bg-surface"
            }`}
          >
            <div
              className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                state.locale === option.value ? "border-ink" : "border-gray2-60"
              }`}
            >
              {state.locale === option.value && <div className="w-3 h-3 rounded-full bg-ink" />}
            </div>
            <span className="text-[27px] text-textcolor-black">{option.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
